import type { ReactNode } from "react";
import { Outlet } from "react-router";

import { Wordmark } from "@/components/layout/Wordmark";

/**
 * The frame for signed-out pages.
 *
 * One panel, centred on the grey frame. Signing in is the only thing on the
 * screen, so nothing else is on it.
 */
export function AuthLayout() {
  return (
    <div className="flex min-h-dvh items-center justify-center px-4 py-10 sm:px-6">
      <div className="w-full max-w-md">
        <div className="rounded-xl bg-surface p-8 ring-1 ring-inset ring-line sm:p-10">
          <Wordmark className="mb-8" />
          <Outlet />
        </div>
        <p className="mt-6 px-2 text-center text-xs text-fg-subtle">
          Licensed by the Central Bank of the UAE. Serving Dubai since 1980.
        </p>
      </div>
    </div>
  );
}

export function AuthCard({
  title,
  description,
  children,
  footer,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <section>
      <h1 className="text-xl font-bold text-fg">{title}</h1>
      {description ? <p className="mt-1.5 text-base text-fg-muted">{description}</p> : null}
      <div className="mt-6">{children}</div>
      {footer ? <div className="mt-6 text-base text-fg-muted">{footer}</div> : null}
    </section>
  );
}
